var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "baseline-mark",
  "use": "baseline-mark-usage",
  "viewBox": "0 0 23 16",
  "content": "<symbol viewBox=\"0 0 23 16\" id=\"baseline-mark\"><path d=\"M14.96 5.366a.4.4 0 0 1-.334-.68l1.658-1.657a2.343 2.343 0 0 1 3.963 1.248.394.394 0 0 1-.338.45c-.943.127-3.456.448-4.95.64zm-1.99 7.605a2.343 2.343 0 0 1-3.314 0l-.974-.975a.4.4 0 0 1 .283-.683h4.697a.4.4 0 0 1 .283.683l-.975.975zM2.716 4.734a.4.4 0 0 1-.345-.459c.092-.468.317-.904.659-1.246a2.343 2.343 0 0 1 3.313 0L8 4.687a.4.4 0 0 1-.334.68c-1.493-.192-4.006-.513-4.95-.633zm18.538-3.362a4.687 4.687 0 0 0-6.627 0l-3.314 3.314L8 1.372A4.687 4.687 0 0 0 1.372 8L8 14.627v.001a4.685 4.685 0 0 0 6.626 0h.001L21.254 8a4.687 4.687 0 0 0 0-6.628\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg-sprite/baseline-mark.svg
// module id = 274
// module chunks = 114276838955818